import { CLIENT_LOGOS } from "../data/content";

const REPEAT = 4;

export const ClientLogoSlider = ({ files, slug }) => {
  const logos = files.map((f) => CLIENT_LOGOS.find((l) => l.file === f)).filter(Boolean);
  const items = Array.from({ length: REPEAT }, () => logos).flat();
  if (logos.length < 5) {
    return (
      <div data-testid={`logo-slider-${slug}`} className="mt-12 flex flex-wrap items-center justify-center gap-x-12 gap-y-6 lg:mt-16 lg:gap-x-16" aria-label={`${logos.length} client logos`}>
        {logos.map((l) => (
          <img key={l.file} src={`/images/clients/${l.file}.png`} alt={`${l.name} logo`} loading="lazy" decoding="async" width="200" height="48" className="h-10 w-auto max-w-[160px] object-contain sm:h-12 sm:max-w-[200px]" />
        ))}
      </div>
    );
  }
  return (
    <div data-testid={`logo-slider-${slug}`} className="marquee marquee-compact mt-12 lg:mt-16" aria-label={`${logos.length} client logos`}>
      <div className="marquee-track" style={{ animationDuration: `${logos.length * 3.2}s` }}>
        {items.map((l, i) => (
          <div key={`${l.file}-${i}`} className="marquee-item" aria-hidden={i >= logos.length ? "true" : undefined}>
            <img src={`/images/clients/${l.file}.png`} alt={i < logos.length ? `${l.name} logo` : ""} loading="lazy" decoding="async" width="200" height="48" className="h-8 w-auto max-w-[140px] object-contain sm:h-10 sm:max-w-[180px]" />
          </div>
        ))}
      </div>
    </div>
  );
};
